import type { InventoryRepository } from '../inventory'
import { get, post } from './transport'

const enc = encodeURIComponent

export function inventoryHttp(): InventoryRepository {
  return {
    correctCount: (itemId, counted, note) =>
      post<{ onShelf: number }>(`/api/inventory/items/${encodeURIComponent(itemId)}/count`, { counted, note }),
    inventory: () => get('/api/inventory'),
    inventorySummary: () => get('/api/inventory/summary'),
    item: (id) => get(`/api/inventory/items/${enc(id)}`),
    categories: () => get('/api/inventory/categories'),
    addCategory: (name) => post('/api/inventory/categories', { name }),
    renameCategory: (id, name) => post(`/api/inventory/categories/${enc(id)}`, { name }, 'PATCH'),
    deleteCategory: (id) => post(`/api/inventory/categories/${enc(id)}/delete`, {}),
    createItem: (input) => post('/api/inventory/items', input),
    receipts: (filter = {}) => {
      const params = new URLSearchParams()
      if (filter.itemId) params.set('itemId', filter.itemId)
      if (filter.limit) params.set('limit', String(filter.limit))
      const q = params.toString()
      return get(`/api/receipts${q ? `?${q}` : ''}`)
    },
    receive: (input) => post('/api/receipts', input),
  }
}
